import OffresController from './offres.controller';

export default {
    template: require('./offres.tpl.html'),
    controller: OffresController
};
